// Browser glue for WebAuthn flows. The backend hands us spec-shaped publicKey
// blobs with base64url strings; the browser API requires ArrayBuffers, so we
// convert here and back on the way out.

import { api } from "./api";

function b64uToBytes(s) {
  s = s.replace(/-/g, "+").replace(/_/g, "/");
  while (s.length % 4) s += "=";
  const bin = atob(s);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}
function bytesToB64u(buf) {
  const bin = String.fromCharCode(...new Uint8Array(buf));
  return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

function inflateCreate(pk) {
  pk.challenge = b64uToBytes(pk.challenge);
  pk.user.id = b64uToBytes(pk.user.id);
  if (pk.excludeCredentials) {
    pk.excludeCredentials = pk.excludeCredentials.map((c) => ({ ...c, id: b64uToBytes(c.id) }));
  }
  return pk;
}
function inflateGet(pk) {
  pk.challenge = b64uToBytes(pk.challenge);
  if (pk.allowCredentials) {
    pk.allowCredentials = pk.allowCredentials.map((c) => ({ ...c, id: b64uToBytes(c.id) }));
  }
  return pk;
}
function deflateAttestation(cred) {
  return {
    id: cred.id,
    rawId: bytesToB64u(cred.rawId),
    type: cred.type,
    response: {
      attestationObject: bytesToB64u(cred.response.attestationObject),
      clientDataJSON: bytesToB64u(cred.response.clientDataJSON),
    },
    extensions: cred.getClientExtensionResults?.() || {},
  };
}
function deflateAssertion(cred) {
  return {
    id: cred.id,
    rawId: bytesToB64u(cred.rawId),
    type: cred.type,
    response: {
      authenticatorData: bytesToB64u(cred.response.authenticatorData),
      clientDataJSON: bytesToB64u(cred.response.clientDataJSON),
      signature: bytesToB64u(cred.response.signature),
      userHandle: cred.response.userHandle ? bytesToB64u(cred.response.userHandle) : null,
    },
    extensions: cred.getClientExtensionResults?.() || {},
  };
}

export async function registerPasskey(name) {
  const { data } = await api.post("/webauthn/register/begin", { name });
  const pk = inflateCreate(data.publicKey);
  const cred = await navigator.credentials.create({ publicKey: pk });
  const out = deflateAttestation(cred);
  await api.post("/webauthn/register/finish", { state_handle: data.state_handle, credential: out });
}

export async function loginWithPasskey(email) {
  const { data } = await api.post("/webauthn/login/begin", { email });
  const pk = inflateGet(data.publicKey);
  const cred = await navigator.credentials.get({ publicKey: pk });
  const out = deflateAssertion(cred);
  await api.post("/webauthn/login/finish", { state_handle: data.state_handle, credential: out });
}
